import client from '../utils/client';
import { gql } from '@apollo/client';

type Error =
	| 'USER_NOT_FOUND'
	| 'INVITED_USERS_ONLY'
	| 'INVITE_EXPIRED'
	| 'CREDENTIALS_DO_NOT_MATCH'
	| 'NETWORK_ERROR';

const inviteLogin = async (
	email: string,
	password: string
): Promise<
	| { success: true; jwt: string; error: undefined }
	| { success: false; jwt: undefined; error: Error }
> => {
	try {
		const { data, errors } = await client.mutate({
			mutation: gql`
				mutation InviteLogin($email: String!, $password: String!) {
					inviteLogin(email: $email, password: $password) {
						success
						jwt
					}
				}
			`,
			variables: { email, password },
			errorPolicy: 'all',
		});
		if (errors) {
			return {
				success: false,
				error: errors[0]?.extensions?.code as Error,
				jwt: undefined,
			};
		}
		return {
			success: true,
			jwt: data.inviteLogin.jwt,
			error: undefined,
		};
	} catch (e) {
		if (e && e.networkError) return { success: false, error: 'NETWORK_ERROR', jwt: undefined };
		throw e;
	}
};

export default inviteLogin;
